import { Asset } from 'app-lib/assetUtils'
import { DEX } from 'app-lib/dexSelector/types'
import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'
import { BigNumber } from '@0x/utils'
import { getBaseQuote, IChainConfig, udfFeeds } from './chainCommon'

const assets = [Asset.DAI, Asset.USDT, Asset.USDC, Asset.ETH, Asset.OP, Asset.WBTC, Asset.FRAX]

const tradePairs: [Asset, Asset][] = [
  [Asset.DAI, Asset.ETH],
  [Asset.DAI, Asset.FRAX],
  [Asset.DAI, Asset.OP],
  [Asset.DAI, Asset.USDC],
  [Asset.DAI, Asset.USDT],
  [Asset.DAI, Asset.WBTC],
  [Asset.ETH, Asset.FRAX],
  [Asset.ETH, Asset.USDC],
  [Asset.ETH, Asset.USDT],
  [Asset.ETH, Asset.WBTC],
  [Asset.OP, Asset.FRAX],
  [Asset.OP, Asset.USDC],
  [Asset.OP, Asset.USDT],
  [Asset.OP, Asset.WBTC],
  [Asset.OP, Asset.WETH],
  [Asset.USDC, Asset.FRAX],
  [Asset.USDC, Asset.USDT],
  [Asset.USDT, Asset.FRAX],
  [Asset.WBTC, Asset.FRAX],
  [Asset.WBTC, Asset.USDC],
  [Asset.WBTC, Asset.USDT],
]

// add iTokens as collateral
const collateralAssets: Asset[] = assets.concat(assets.map((asset) => ('I' + asset) as Asset))

const config: IChainConfig = {
  chainDetails: {
    chainId: 10,
    blockExplorer: 'https://optimistic.etherscan.io',
    chainName: 'Optimism Mainnet',
    shortName: 'Optimism',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.ankr.com/optimism'],
    blocksPerYear: (60 * 60 * 24 * 365) / 15,
  },
  borrowing: { assets, collateralAssets },
  comingSoon: {
    tokens: {},
  },
  contracts: {
    bzx: '0xAcedbFd5Bc1fb0dDC948579d4195616c05E74Fd1',
    helperProxy: '0x3920993FEca46AF170d296466d8bdb47A4b4e152',
    priceFeed: '0x37A3fC76105c51D54a9c1c3167e30601EdeE8782',
    sweepFees: '', // TODO
    tokenRegistry: '0x22a2208EeEDeb1E2156370Fd1c1c081355c68f2B',
  },
  dexes: [DEX.UNISWAPV3],
  dexesDetails: {
    [DEX.UNISWAPV3]: { id: 2, address: '0x65F869921BB4256dAe84e24Dead1177ab43D6845' },
  },
  features: { dexSelector: false },
  gas: {
    priceDefault: new BigNumber(5).times(10 ** 9), // TODO
    amount: { coefficient: 2, fallback: 450000 }, // TODO
  },
  lending: { assets },
  protocol: { version: 4 },
  trading: {
    defaultPair: { baseToken: Asset.ETH, quoteToken: Asset.USDT },
    pairs: tradePairs,
    baseQuote: getBaseQuote(tradePairs),
    pairConfigs: {},
  },
  native: { asset: Asset.ETH, wrapped: Asset.WETH },
  nativeTokenSupported: true,
  compromisedContracts: [],
  icon: { name: 'chain-optimism', color: '' },
  chartUDF: udfFeeds.BINANCE,
  rpcUrlDefault: process.env.RPC_URL_OPTIMISM,
  stableCoins: [Asset.USDC, Asset.USDT, Asset.DAI, Asset.FRAX],
  stablecoinForUsdRates: Asset.USDC,
  stats: { assets },
  twitterHandle: '@optimismPBC',
  uiDisabled: false,
  uiDisabledReason: '',
  wallets: [ProviderType.MetaMask],
  uniRouteSettings: {},
}

export default config
